module.exports = __webpack_public_path__ + "img/logo.ad2c716f.png";